<template>
    <div :data-component="$options.name">
        <cs-modal
            :visible="isVisible"
            :isFullscreen="!isScreenM"
            :headerText="'Inhalt melden'"
            channel="real-estate"
            @update:visible="emitCloseModalEvent"
        >
            <form
                v-if="!showSuccessView"
                id="form1"
                ref="formElement"
                @submit.prevent="onSubmit"
            >
                <div class="flex flex-col mb-16 p-16 rounded-10 bg-white shadow">
                    <p class="text-text-l font-bold mb-16">Warum möchtest du dieses Immobilienangebot melden?</p>
                    <div class="text-text-l mb-8">Das Immobilienangebot...</div>
                    <cs-radio-button
                        v-for="(complaintReason, index) in complaintReasons"
                        :key="index"
                        v-model="formData.reason"
                        name="reason"
                        :value="complaintReason"
                        :showError="showErrorMessage"
                        :errorMsg="getErrorMessage(index)"
                        @update:modelValue="updateComplaints"
                        >{{ complaintReason }}</cs-radio-button
                    >
                </div>

                <div class="flex flex-col p-16 mb-16 rounded-10 bg-white shadow text-text-l">
                    <p class="font-bold mb-16">Was möchtest du uns noch mitteilen?</p>
                    <cs-textarea
                        v-model="formData.message"
                        label="Nachricht"
                        :limit="2500"
                        :rows="6"
                    />
                </div>

                <p class="text-caption">
                    Ein Beschwerdeformular auf der Grundlage des EU Digital Services Act findest du
                    <cs-dsa-report-link
                        channel="realEstate"
                        :reference="exposeeId.toString()"
                        text="hier"
                    />
                </p>
            </form>
            <div
                v-else
                ref="successPage"
                class="flex flex-col items-center p-16 rounded-10 bg-white shadow"
            >
                <ms-form-success class="mb-16" />
                <ms-headline
                    type="h3"
                    :isSpan="true"
                    class="mb-16"
                    >Wir danken dir sehr für deine Meldung</ms-headline
                >
                <p class="text-text-l text-center">
                    Durch deine Hilfe beugen wir Betrug bei meinestadt.de vor. Wir prüfen das Immobilienangebot und
                    leiten entsprechende Maßnahmen ein. <br />
                    <br />
                    Bitte beachte, dass du auf deine Meldung keine Antwort erhältst.
                </p>
            </div>
            <template
                v-if="!showSuccessView"
                #buttons
            >
                <cs-primary-button
                    class="w-full screen-m:w-fit"
                    :type="'submit'"
                    form="form1"
                    :isCentered="true"
                    :isDisabled="isDisabled"
                >
                    Inhalt melden
                </cs-primary-button>
            </template>
        </cs-modal>
    </div>
</template>
<script lang="ts" src="./MsDetailModalReport.ts" />
